import en from './en.json'
import it from './it.json'

export const commonTranslations = {
	en,
	it
} as const
